import adminAccountController from "@/js/helpers/adminAccountController";
import store from "@/js/store/index";
import { isOldUserForNewUI } from "@/js/services/ApiVersionService";
import { failedUserStatus } from "@/js/helpers/failedUserStatus";
import { isObject } from "@/js/helpers/utils";
import {
	changeReminderStatus,
	getReminderByType,
	isReminderEnabled
} from "@/js/services/VersionSyncService";

export function canEmailLeadsExport() {
	return adminAccountController.isAdmin() && store.getters.sideAccountId;
}

export function canSeeNewUIGuide() {
	const hasNewUiGuide = isReminderEnabled("NEW_UI_GUIDE");

	return isOldUserForNewUI() && hasNewUiGuide && !store.getters.freeTrialEnds;
}

export async function checkAndSetNewUiTour() {
	await store.dispatch("getReminders");
	const newUiGuideReminder = getReminderByType("NEW_UI_GUIDE");

	if (isOldUserForNewUI() && !newUiGuideReminder) {
		await changeReminderStatus("NEW_UI_GUIDE", false);
	}
}

export function inviteByEmailFeatureIsEnabled() {
	return store.getters.currentUser.inviteByEmailEnabled;
}

export function userHasAccessToDashboard(user) {
	return isObject(user) && (!failedUserStatus(user.status) || user.onboardingCompleted);
}

export async function isLeadsFilterFeatureEnabled() {
	return await store.dispatch("hasFeature", "LEADS_FILTER");
}

export function userIsTryingToConnectOtherLiAccount(errorObj) {
	return errorObj.status === 409 && errorObj.error === "UNAUTHORIZED";
}
